<template>
  <h4>NonStandardWeaponPerson.vue</h4>
</template>

<script>
export default {
  data() {},
  created() {},
  computed: {},
  methods: {},
};
</script>

<style scoped></style>
